module.exports = __webpack_public_path__ + "img/pro_s2_icon9.745c4ddf.png";